import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path fill="currentColor" fillRule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" clipRule="evenodd" />
        <path
            stroke="#4D1D00"
            strokeLinecap="round"
            strokeWidth={1.2}
            d="M7.278 12.139s1-.583 2.722-.583 2.722.583 2.722.583"
        />
        <path
            fill="#4D1D00"
            stroke="#4D1D00"
            d="M8.139 9.222a.278.278 0 1 1-.556 0 .278.278 0 0 1 .556 0ZM12.417 9.222a.278.278 0 1 1-.556 0 .278.278 0 0 1 .556 0Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
